import { useMemo, useState } from 'react';

import {
  ChakraBox,
  FAIconName,
  FireflyTertiaryButtonMenu,
} from '@equip.health/ui';
import { DateTime } from 'luxon';
import { useGetProviderTimezonesEnumQuery } from '~/store/services/enumerations';

const TOP_LEVEL_ID = 'timezone-menu-v2';

const localTz = DateTime.now().zoneName;

const TimezoneMenuV2 = ({ onChange }) => {
  const [selectedTimezone, setSelectedTimezone] = useState<string>(null);

  const { data: timezones } = useGetProviderTimezonesEnumQuery();

  const timezonesMenuOptions = useMemo(
    () =>
      (timezones ?? []).map(({ id, label }) => ({
        label,
        node: id,
      })),
    [timezones],
  );

  const handleSelect = (option: string) => {
    setSelectedTimezone(
      timezones.find((timezoneOption) => timezoneOption.id === option).label,
    );
    onChange(option);
  };

  if (timezones?.length && selectedTimezone === null) {
    const found = timezones.find((tz) => tz.id === localTz);
    if (found) {
      setSelectedTimezone(found.label);
    }
  }

  if (!selectedTimezone) return null;

  return (
    <ChakraBox maxHeight="300px" overflow="auto">
      <FireflyTertiaryButtonMenu
        buttonId={TOP_LEVEL_ID}
        buttonLeftIcon={FAIconName.mapMarkerAltRegular}
        buttonText={selectedTimezone}
        maxHeight="250px"
        maxWidth="250px"
        onOptionClick={(e) => handleSelect(e)}
        options={timezonesMenuOptions}
      />
    </ChakraBox>
  );
};

export default TimezoneMenuV2;
